import { AxfoodApi } from '@occ/api-client';

const axfoodApi = new AxfoodApi({
  baseUrl: '',
});

export const getAddressLineSuggestions = async (addressline: string, maxRows = '20') => {
  const response = await axfoodApi.getAddressSuggestionsUsingGet({ addressline, maxRows });
  return response.data.suggestions || [];
};

export const validateFullAddress = (line: string) => axfoodApi.getValidatedAddressLineUsingGet({ line });

export const getStreetSuggestions = async (query: string, postalCode?: string, maxRows = '100') => {
  const response = await axfoodApi.getAddressSuggestionsUsingGet1({ query, postalCode, maxRows });
  return response.data.suggestions || [];
};

export const getDeliveryAvailableAddressLine = (line: string) =>
  axfoodApi.isDeliveryAvailableForAddressLineUsingGet({ line });

export const validateStreetAddress = async (street: string, locality: string, postalCode: string) => {
  const response = await axfoodApi.getValidatedAddressUsingGet({ street, locality, postalcode: postalCode });
  return response.data.response;
};

export const getDeliverability = (postalCode: string, b2b?: boolean) =>
  axfoodApi.getDeliverabilityUsingGet(postalCode, { b2b });

export const getDeliveryAvailable = (street: string, postalcode: string, locality: string) =>
  axfoodApi.isDeliveryAvailableUsingGet({ street, postalcode, locality });
